import React from "react";
import Navbar from "../components/Navbar";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faPlane,
  faTaxi,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { faBuilding } from "@fortawesome/free-regular-svg-icons";
import Footer from "../components/Footer";

const About = () => {
  const cities = [
    {
      name: "Havana",
      image:
        "https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/cities-02.jpg",
    },
    {
      name: "Kingston",
      image:
        "https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/cities-03.jpg",
    },
    {
      name: "Santo Domigo",
      image:
        "https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/cities-01.jpg",
    },
    {
      name: "George Town",
      image:
        "https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/cities-04.jpg",
    },
  ];

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const secondCarouselSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 922,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 743,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="bg-gray-800">
      <Navbar />
      <section
        className="flex items-center justify-center pb-0 md:pb-20 bg-fixed bg-center bg-no-repeat h-[100vh] md:h-[150vh]"
        style={{
          backgroundImage: `url(${"https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/about-content-bg.jpg"})`,
        }}
      >
        <div className="flex flex-col items-center  justify-center w-[88%] text-white bg-black h-3/5 md:h-3/5 rounded-3xl bg-opacity-20 backdrop-blur px-4 md:px-52 text-center">
          <h3 className="text-xl">EXPOLRE OUR COUNTRY</h3>
          <div className="w-24 h-[2px] bg-gray-400 mt-2 md:mt-4"></div>
          <h1 className="text-2xl md:text-6xl mt-4 md:mt-8 font-bold">
            Welcome To Caribbean
          </h1>
          <p className=" mt-4 md:mt-8 ">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt uttersi labore et dolore magna aliqua is
            ipsum suspendisse ultrices gravida
          </p>
          <NavLink
            className={
              "bg-white py-3 font-semibold hover:bg-gray-200 px-8 mt-8 text-cyan-500 rounded-full"
            }
          >
            Discover More
          </NavLink>
        </div>
      </section>
      <section className="bg-gray-800 pb-10 flex flex-col items-center justify-center">
        <div
          style={{ marginTop: "-100px" }}
          className=" w-11/12 py-6 md:py-8 rounded-3xl  bg-gray-50 px-6 md:px-11"
        >
          <div className="flex justify-between text-black text-3xl font-bold">
            <h1>
              Caribbean’s
              <span className="text-cyan-500"> Cities & Towns</span>
            </h1>
            <div className="flex justify-between w-12 text-lg text-gray-300">
              <button className="hover:text-cyan-500">
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <button className="hover:text-cyan-500">
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          </div>
          <div className="w-full mt-8">
            <Slider {...settings}>
              {cities.map((city, index) => (
                <div className="   p-3">
                  <div className="flex items-center justify-center">
                    <div
                      key={index}
                      className=" w-60 h-60 rounded-3xl text-white flex  items-end font-semibold text-xl p-5 bg-center bg-no-repeat "
                      style={{
                        backgroundImage: `url(${city.image})`,
                      }}
                    >
                      <h1>{city.name}</h1>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-center w-full">
          <h1 className="text-center text-white text-4xl font-semibold">
            Best Weekly Offers In Each City
          </h1>
          <p className="text-white mt-3 w-3/4 md:w-2/4 text-center">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore.
          </p>
          <div className="w-full mt-20 px-10">
            <Slider {...secondCarouselSettings}>
              {cities.map((city) => (
                <div>
                  <div className="flex items-center justify-center">
                    <div className="relative w-[300px] h-[420px]">
                      <div className="w-56 md:w-64 z-0 absolute">
                        <img
                          className="w-[70%] rounded-bl-3xl"
                          src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/offers-03.jpg"
                          alt="George Town"
                        />
                      </div>
                      <div className="bg-white absolute top-20 left-14 z-10 w-56 md:w-64 px-4 md:px-6 py-4 md:py-7 rounded-3xl">
                        <div className="flex justify-between ">
                          <div>
                            <h1 className="font-bold text-lg md:text-xl">
                              {city.name}
                            </h1>
                            <p className="text-gray-400">
                              <FontAwesomeIcon
                                icon={faUsers}
                                className="mr-1"
                              />
                              234 Check ins
                            </p>
                          </div>
                          <div>
                            <h1 className="font-bold text-lg md:text-xl text-cyan-500">
                              $420
                            </h1>
                            <p className="text-gray-400">/person</p>
                          </div>
                        </div>
                        <div className="mt-6 ">
                          <h1 className="text-base font-bold text-gray-700">
                            Deals Includes:
                          </h1>
                          <p className="text-gray-400 mt-3">
                            <FontAwesomeIcon icon={faTaxi} /> 5 Day Trip>Hotel
                            Included
                          </p>
                          <p className="text-gray-400 mt-2">
                            <FontAwesomeIcon icon={faPlane} /> Airplane Bill
                            Included
                          </p>
                          <p className="text-gray-400 mt-2">
                            <FontAwesomeIcon icon={faBuilding} /> Airplane Bill
                            Included
                          </p>
                          <div className="flex justify-center mt-7">
                            <NavLink
                              className={
                                "bg-cyan-500 py-2 md:py-3 px-4 md;px-7  font-normal md:font-semibold rounded-full text-white"
                              }
                            >
                              Make A Reservation
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <section className="bg-gray-800 flex flex-col md:flex-row justify-between mt-8 text-gray-200 px-5  md:px-16">
        <div className="w-full md:w-1/2">
          <h1 className="text-4xl text-cyan-500 font-semibold">Discover More About Our Country</h1>
          <p className="my-3 w-[100%]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore.
          </p>
          <img  className="rounded-xl w-[100%] " src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/about-left-image.jpg" alt="Descover More About Our Country"/>
        </div>
        <div className="w-full md:w-1/2 ml-0 md:ml-7 py-5 flex flex-col items-start">
          <div className=" w-full flex justify-between">
            <div className="bg-gray-200 text-gray-800 w-1/2 px-2 md:px-5  py-6 rounded-xl">
              <h1 className="font-bold text-xl">150.640+</h1>
              <p className="text-cyan-500 text-lg">Total Guests Yearly</p>
            </div>
            <div className="bg-gray-200 ml-4 md:ml-7 text-gray-800 w-1/2 px-2 md:px-5 py-6  rounded-xl">
              <h1 className="font-bold text-xl">175.000+</h1>
              <p className="text-cyan-500 text-lg">Amazing Accomoditations</p>
            </div>
          </div>
          <div className="flex w-full bg-gray-200 mt-4 md:mt-7 text-gray-800 rounded-xl px-5 py-6">
            <div className="w-1/2">
              <h1 className="text-xl font-bold">12.560+</h1>
              <p className="text-lg text-cyan-500">Amazing Places</p>
            </div>
            <div className="w-1/2">
              <h1  className="text-xl font-bold">240.580+</h1>
              <p className="text-lg text-cyan-500">Different Check-ins Yearly</p>
            </div>
          </div >
            <p className="mt-8">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore.
            </p>
            <Link
              to={"/reservation"}
              className={
                "bg-cyan-500 py-3 font-semibold hover:bg-cyan-600 px-8 mt-12 text-gray-200 rounded-full"
              }
            >
              Descover More
            </Link>
        </div>
      </section>
      <section
        className=" mt-16 flex flex-col md:flex-row justify-between items-center text-gray-200 py-20 px-12  bg-center"
        style={{
          backgroundImage: `url(${"https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/cta-bg.jpg"})`,
        }}
      >
        <div className="flex flex-col items-center md:items-start text-center md:text-start">
          <h1 className="text-5xl font-bold">Are You Looking To Travel ?</h1>
          <p className="mt-5 text-lg font-bold">
            Make A Reservation By Clicking The Button
          </p>
        </div>
        <button className="bg-transparent mt-5 md:mt-0 hover:bg-white hover:text-cyan-500 border border-white text-white transition-all h-12   text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold">
          Book Yours Now
        </button>
      </section>
      <Footer/>
    </div>
  );
};

export default About;
